import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-78d60818")
const _hoisted_1 = { class: "page sign_up_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Registrazione", -1)
const _hoisted_3 = { class: "p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_6 = { class: "p-col-12 p-md-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-briefcase" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Inserire almeno uno tra i due dei seguenti campi ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "p-col-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" }, null, -1)
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col-12 p-md-6" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Il risultato della ricerca verrà applicato ai relativi campi. ")
], -1)
const _hoisted_17 = { class: "p-col-12 p-md-6" }
const _hoisted_18 = { class: "actions" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_VInputText = _resolveComponent("VInputText")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Password = _resolveComponent("Password")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_AppLogo, { width: "300" }),
      _hoisted_2
    ]),
    _createElementVNode("form", {
      id: "registration_form",
      class: "p-grid",
      autocomplete: "nope",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.user_data')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.name') + '*',
              field: "name"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.surname') + '*',
              field: "surname"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.email') + '*',
              field: "email"
            }, null, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.password')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('user.password') + '*'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Password, {
                  modelValue: _ctx.pwd,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.pwd = $event)),
                  class: _normalizeClass({ 'p-invalid' : _ctx.pwdErrors?.length > 0 }),
                  feedback: false,
                  toggleMask: ""
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pwdErrors, (e) => {
              return (_openBlock(), _createElementBlock("p", {
                key: `pwd_${e}`,
                class: "p-error"
              }, _toDisplayString(_ctx.$t(e)), 1))
            }), 128)),
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('user.confirm_password') + '*',
              class: "p-mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Password, {
                  modelValue: _ctx.cpwd,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cpwd = $event)),
                  class: _normalizeClass({ 'p-invalid' : _ctx.cpwdErrors?.length > 0 }),
                  feedback: false,
                  toggleMask: ""
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cpwdErrors, (e) => {
              return (_openBlock(), _createElementBlock("p", {
                key: `cpwd_${e}`,
                class: "p-error"
              }, _toDisplayString(_ctx.$t(e)), 1))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.business_data')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.business_name') + '*',
              field: "business_name"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.business_tel') + '*',
              field: "business_tel",
              maxlength: "15",
              type: "tel"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.email') + '*',
              field: "business_email",
              type: "email"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.pec'),
              field: "business_pec",
              type: "email"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('entity.sdi'),
              field: "business_sdi"
            }, null, 8, ["label"]),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.hasVatOrFcError ? 'p-error': 'p-text-secondary')
            }, _hoisted_10, 2),
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('entity.vat'),
              class: "p-field"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.vat,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vat = $event)),
                  class: _normalizeClass({'p-invalid': _ctx.hasVatOrFcError})
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('entity.fiscal_code')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.fc,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fc = $event)),
                  class: _normalizeClass({'p-invalid': _ctx.hasVatOrFcError})
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Fieldset, { class: "p-fluid" }, {
          legend: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.geo_data')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('entity.business_city') + '*',
                  class: "p-field"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AutoComplete, {
                      modelValue: _ctx.business_city,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.business_city = $event)),
                      class: _normalizeClass({ 'p-invalid' : _ctx.hasError('business_city_name') }),
                      suggestions: _ctx.citiesSuggestions,
                      field: "name",
                      onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchCity($event))),
                      onItemSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCity($event.value)))
                    }, null, 8, ["modelValue", "class", "suggestions"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_AddressAutocomplete, {
                    modelValue: _ctx.business_address,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.business_address = $event)),
                    label: "Cerca indirizzo *",
                    onSelectedAddress: _ctx.onSelectAddress
                  }, null, 8, ["modelValue", "onSelectedAddress"]),
                  _hoisted_16
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_VInputText, {
                  label: _ctx.$t('entity.business_address') + '*',
                  field: "business_address"
                }, null, 8, ["label"]),
                _createVNode(_component_VInputText, {
                  label: _ctx.$t('entity.business_state'),
                  field: "business_state"
                }, null, 8, ["label"]),
                _createVNode(_component_VInputText, {
                  label: _ctx.$t('entity.business_province'),
                  field: "business_province"
                }, null, 8, ["label"]),
                _createVNode(_component_VInputText, {
                  label: _ctx.$t('entity.business_postal_code') + '*',
                  field: "business_postal_code"
                }, null, 8, ["label"])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ], 32),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Button, {
        loading: _ctx.isSubmitting,
        form: "registration_form",
        icon: "pi pi-save",
        label: _ctx.$t('login.sign_up'),
        type: "submit"
      }, null, 8, ["loading", "label"])
    ])
  ]))
}